import { getRequestHeaders } from 'config/requestConfig'
import { useState } from 'react'
import { useAuthContext } from 'shared/components'
import { LoadingStatus } from 'shared/types'

export const useGetImage = () => {
  const { auth } = useAuthContext()
  const [imageSrc, setImageSrc] = useState<string | undefined>()
  const [loading, setLoading] = useState<LoadingStatus>(LoadingStatus.Idle)
  const getImage = async (imageUrl: string) => {
    if (!auth) return
    setLoading(LoadingStatus.Pending)
    try {
      const requestHeaders = await getRequestHeaders(auth)
      const response = await fetch(imageUrl, { headers: requestHeaders })
      const imageBlob = await response.blob()
      const imageSrc = URL.createObjectURL(imageBlob)
      setImageSrc(imageSrc)
      setLoading(LoadingStatus.Succeeded)
      return imageSrc
    } catch (e) {
      setLoading(LoadingStatus.Failed)
    }
  }
  return { imageSrc, getImage, loading }
}
